import Module from '../../Module';
import { Cover } from '../'

class CategoryService extends Module {
  /**
   * parse category
   * @param {Object} categoty
   */
  parseCategory(categoty) {
    return {
      active: categoty.active,
      coverId: categoty.coverId,
      description: categoty.description,
      id: categoty.id,
      title: categoty.title,
      cover: categoty.cover ? Cover.parseCover(categoty.cover) : null
    }
  }
}

export default new CategoryService()
